import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { GridDataResult, DataStateChangeEvent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { clone, cloneDeep } from 'lodash';
import { V6ProductType } from '../../../../core/enums';
import { IProductTemplate, IV6Product, ProductTemplate } from '../../../../core/models';
import { ProductService } from '../../../../core/services/product.service';
import { UserService } from '../../../../core/services/user.service';
import { V6productService } from '../../../../core/services/v6product.service';

import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
@Component({
  selector: 'app-manage-product',
  templateUrl: './manage-product.component.html',
  styleUrls: ['./manage-product.component.scss']
})
export class ManageProductComponent implements OnInit {
  manageProductGridView: GridDataResult;
  productTemplates: IV6Product[] = [];
  constructor(private userService: UserService,
    private router: Router,
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private v6productService: V6productService
    , private appNotifyService: AppNotifyService,
  ) {

  }
  public productGridState: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'productId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  //productGridState: State;
  ngOnInit() {
    this.productGridState = this.v6productService.tempGridState();
    this.productService.getAllProductTemplate().subscribe(productTemplates => {
      console.log(productTemplates);
      this.productTemplates = productTemplates;
      this.loadProductGridData();
    });
  }

  //#region product grid data binding
  productLoading: boolean;
  public loadProductGridData(): void {
    this.productLoading = true;
    this.manageProductGridView = process(this.productTemplates, this.productGridState);
    this.productLoading = false;

  }
  //#endregion
  //#region pagination, sorting,filtering for Product grid




  public productGridSortChange(sort): void {
    this.productGridState.sort = sort;
    this.loadProductGridData();
  }

  public productGridPageChange({ skip, take }: PageChangeEvent): void {
    this.productGridState.skip = skip;
    this.productGridState.take;
    this.loadProductGridData();
  }

  public productGridDataStateChange(state: DataStateChangeEvent): void {
    this.productGridState = state;
    this.loadProductGridData();
  }

  public goToConfigProduct(productTemplate: IV6Product, routepath: string) {
    //temp poc lines
    this.productService.selectedProductTemplate = productTemplate;
    this.router.navigate([routepath]);
  }
  createProduct(routepath: string) {
    this.v6productService.createProduct();
    this.router.navigate([routepath]);
  }
  editProduct(productTemplate: IV6Product, routepath: string) {
    const temp = JSON.parse(productTemplate.templateDescription) as ProductTemplate;
    if (productTemplate.type === '2') {
      temp.type = V6ProductType.KWIK_KEY_DOOR;
    }
    else if (productTemplate.type === '3') {
      temp.type = V6ProductType.KWIK_KEY_FRAME;
    }
    else {
      temp.type = V6ProductType.CONFIGURED;
    }

    this.v6productService.editProduct(temp, productTemplate.id);
    this.router.navigate([routepath]);

  }
  copyProduct(copyproductTemplate: IV6Product, routepath: string) {
    const productTemplate = cloneDeep(copyproductTemplate);
    productTemplate.id=-1;
    const temp = JSON.parse(productTemplate.templateDescription) as ProductTemplate;
    if (productTemplate.type === '2') {
      temp.type = V6ProductType.KWIK_KEY_DOOR;
    }
    else if (productTemplate.type === '3') {
      temp.type = V6ProductType.KWIK_KEY_FRAME;
    }
    else {
      temp.type = V6ProductType.CONFIGURED;
    }

    this.v6productService.editProduct(temp, productTemplate.id);
    this.router.navigate([routepath]);

  }
  //#endregion

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete product ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }

  public RemoveHandler() {
    this.productService.deleteProductTemplate(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const id = this.gridItemToRemove.id;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected Product has been removed.");

      if (this.productTemplates) {
        //This is a Local Remove
        const index = (this.productTemplates).findIndex(r => r.id === id);
        (this.productTemplates).splice(index, 1);
        this.loadProductGridData();

      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }


  //#endregion
}
